export class CreateTripCommand {
  public id: string;
  public description: string;
  public userFacebookId: string;
  public timestamp: Date;
  public updateTime: Date;
  public hubName: string;
  public img: string;
  public title: string;
  public attractions: {
    feedType: string;
    feedId: string;
    order: number;
    item: any;
  }[];
}

export class CreateWholeTripCommand {
  public id: string;
  public description: string;
  public userFacebookId: string;
  public hubName: string;
  public newTrip: any;
  public trips: {
    id: string;
    title: string;
    img: string;
    attractions: {
      feedType: string;
      feedId: string;
      order: number;
    }[];
  }[];
}

export class TripStorageCommand {
  public id: string;
  public userFacebookId: string;
  public timestamp: Date;
  public updateTime: Date;
  public trips: CreateTripCommand[];
  constructor() {
    this.trips = [];
  }
}

export class CreateTripTempCommand {
  public id: string;
  public hubName: string;
  public trips: string;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/commands/visitor/create.trip.command.ts